import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class MortgageApplicationRouterService {
  constructor(protected readonly router: Router) {}

  public goToDeclaration(applicationId: string): void {
    void this.router.navigate(['/application', applicationId, 'declaration']);
  }

  public goToCaseSummary(caseNumber: string): void {
    void this.router.navigate(['/caseOverview', caseNumber, 'caseSummary']);
  }
}
